import { Address } from 'viem';

import { api } from 'modules/api';
import { getPublicClient } from 'modules/api/getPublicClient';

import { getPoolAddresses } from '../methods/getPoolAddresses';

export const EMPTY_POOL_ADDRESSES: Address[] = [];

export const { useGetPoolAddressesQuery } = api.injectEndpoints({
  endpoints: build => ({
    getPoolAddresses: build.query<Address[], void>({
      queryFn: async () => {
        try {
          const client = getPublicClient();

          return { data: await getPoolAddresses(client) };
        } catch {
          const client = getPublicClient();

          return { data: await getPoolAddresses(client) };
        }
      },
    }),
  }),
});
